<template>
  <div :class="classes($style.wrapper, active && $style.wrapperActive)" ref="wrapper">
    <HeaderWithCounter
      :score="score"
      :items="proxyItems"
    >
      <Button @click="runHint" v-if="!lastFound && !isMobile">Получить подсказку</Button>
    </HeaderWithCounter>
    <div :class="classes($style.footer, hintVisible && $style.footerHide)">
      <Button @click="runHint" v-if="!lastFound">Получить подсказку</Button>
    </div>
    <div :class="$style.map" ref="map">
      <div :class="$style.mapImage"><slot/></div>
    </div>
    <Transition name="fade">
      <PopupWithQuestions
        v-if="lastFound"
        @success="() => successAnswer(lastFound)"
        @fail="() => failAnswer()"
        :question="lastFound.question"
        :answers="lastFound.answers"
        :about="lastFound.about"
        :image="lastFound.imageFound"
        :animation="lastFound.animation"
      />
    </Transition>
    <Transition name="fade-right-bottom">
      <HintChar v-if="hintVisible" :text="charText" :char="charImage" />
    </Transition>
  </div>
</template>
<script>
import { TweenLite } from 'gsap'
import clamp from 'lodash/clamp'
import classes from '@/utils/classes'

import Button from '@/components/@ui/Button/Button.vue'

// import ItemOnMap from './components/ItemOnMap/ItemOnMap.vue'
import PopupWithQuestions from './components/PopupWithQuestions/PopupWithQuestions.vue'
import HintChar from './components/HintChar/HintChar.vue'
import HeaderWithCounter from '@/components/HeaderWithCounter/HeaderWithCounter.vue'

import routerCheck from '@/mixins/routerCheck'

export default {
  name: 'Map',
  components: {
    Button, PopupWithQuestions, HintChar, HeaderWithCounter,
  },
  mixins: [routerCheck],
  props: {
    active: Boolean,
    items: Array,
    image: String,
    taskNumber: Number,
  },
  data() {
    return {
      clamp,
      proxyItems: this.items,
      zoom: 3,
      originalSize: {
        width: 0, height: 0,
      },
      lastFound: null,
      hintVisible: false,
      imageObjects: [],
    }
  },
  created() {
    this.classes = classes
    this.$on('restart', this.restart)
  },
  mounted() {
    const displace = require('displacejs')
    const {
      $refs: { map }, customMove, items, $style,
    } = this
    displace(map, { customMove })

    TweenLite.fromTo(map, 60, { scale: 5 }, { scale: 1 })

    this.imageObjects = items.map(i => ({
      el: document.querySelector(`#${i.domID}`),
      item: i,
    }))
    this.imageObjects.forEach((item, index) => {
      item.el.addEventListener('click', () => this.iveFound(index))
      item.el.classList.add($style.imageItem)
    })

    if (this.active) this.activateMap()

    window.addEventListener('resize', this.resizeMap)
    this.resizeMap()
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeMap)
  },
  methods: {
    // DEPRECATED
    // loadImage() {
    //   const { $refs: { img }, image } = this
    //   const tempImg = document.createElement('img')
    //   tempImg.onload = () => {
    //     img.src = image
    //
    //     this.originalSize = {
    //       width: img.width, height: img.height,
    //     }
    //
    //     this.initWrapper()
    //   }
    //   tempImg.src = image
    // },
    restart() {
      this.initWrapper()
      this.proxyItems = this.items.map((i) => {
        i.found = false
        i.hasRightAnswer = false
        return i
      })
    },
    initWrapper() {
      const { $refs: { map, img }, originalSize: { width, height }, zoom } = this

      map.style.width = `${width / zoom}px`
      map.style.height = `${height / zoom}px`

      img.style.width = '100%'
      img.style.height = '100%'
    },
    customMove(el, x, y) {
      const { $refs: { wrapper } } = this

      const {
        width, height,
      } = wrapper.getBoundingClientRect()

      const {
        width: elWidth, height: elHeight,
      } = el.getBoundingClientRect()

      const newX = clamp(x, -(elWidth - width), 0)
      const newY = clamp(y, -(elHeight - height), 0)

      TweenLite.to(el, 0.1, { left: `${newX}px`, top: `${newY}px` })
    },
    iveFound(index) {
      // eslint-disable-next-line no-shadow
      const { proxyItems } = this

      if (proxyItems[index].found) return

      const newItems = proxyItems.slice()
      newItems[index].found = true
      this.proxyItems = newItems
      this.lastFound = newItems[index]
    },
    successAnswer(item) {
      item.hasRightAnswer = true
      this.proxyItems = this.proxyItems.slice()
      this.lastFound = null

      this.handleAnswer()
    },
    failAnswer() {
      this.lastFound = null

      this.handleAnswer()
    },
    handleAnswer() {
      const foundItems = this.proxyItems.filter(item => item.found)

      if (foundItems.length === this.proxyItems.length) this.$emit('end', this.score)
    },
    runHint() {
      const { hintVisible, $style } = this

      if (hintVisible) return

      const hintItems = this.imageObjects.filter(i => !i.item.found)

      hintItems.forEach(i => i.el.classList.add($style.hint))

      this.hintVisible = true
      setTimeout(() => {
        this.hintVisible = false
      }, 3000)
      setTimeout(() => {
        hintItems.forEach(i => i.el.classList.remove($style.hint))
      }, 6000)
    },
    activateMap() {
      TweenLite.to(this.$refs.map, 0.5, { scale: 1, onComplete: this.resizeMap })
    },
    resizeMap() {
      const svg = this.$refs.map.querySelector('svg')
      if (!svg) return

      this.$refs.map.style.left = ''
      this.$refs.map.style.top = ''

      svg.style.height = ''
      svg.style.width = ''

      const { height, width } = svg.getBoundingClientRect()
      const aspectRatio = height / width
      const vh = window.innerHeight

      if (height < vh) {
        svg.style.height = `${vh}px`
        svg.style.width = `${vh / aspectRatio}px`
      }
    },
  },
  computed: {
    score() {
      return this.proxyItems.filter(item => item.found).length
        + this.proxyItems.filter(item => item.hasRightAnswer).length
    },
    isMobile() {
      return this.$store.state.utils.isMobile
    },
    charText() {
      if (this.taskNumber === 0) return 'Присмотрись внимательнее. Пока никто не видит, я подскажу, где находятся нужные устройства.'

      return 'Попробуй посмотреть на предметы в комнате под другим углом. Иногда привычные вещи могут выполнять ещё какую-то функцию.'
    },
    charImage() {
      // return require('./assets/chars/marusya.svg')
      if (this.taskNumber === 0) return require('./assets/chars/zpt.svg')
      return require('./assets/chars/zpt2.svg')
    },
  },
  watch: {
    zoom() {
      this.initWrapper()
    },
    active() {
      if (this.active) this.activateMap()
    },
  },
}
</script>
<style lang="scss" module>
@import './Map.scss';
</style>
